module.exports = __webpack_public_path__ + "img/covid19_splash.674649f6.jpg";